import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import PropTypes from 'prop-types';

class MessageModal extends React.Component {

  render() {
    const parcels = [];
    if (this.props.messageText) {
      this.props.messageText.map((i, y) => (parcels.push(i)));
    }
    const parcelsText = parcels.join('; ');
    return (
      <Modal show={this.props.openModal} onHide={this.props.closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>{'Komunikat'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.props.message === 1 ?
          <h4>Wybrano działkę, która nie istnieje badź leży poza terenem gminy</h4>
          : null
          }
          {this.props.message === 2 ?
          <text>
            <h4>Poniższe działki nie mają pokrycia w MPZP:</h4>
            <i style={{ textAlign: 'justify' }}>{parcelsText}</i>
          </text> : null
          }
          {this.props.message === 3 ?
          <text>
            <h4>
            Jeżeli nieruchomość położona jest w granicach miejscowego planu zagospodarowania przestrzennego, należy skorzystać z usługi
             <a href={`https://e-spdp.pl/eservices?district=${this.props.teryt}&serviceType=WypisIWyrysZMpzp`}>wypisu i wyrysu z miejscowego planu zagospodarowania przestrzennego</a>.
            </h4>
          </text> : null
          }
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.closeModal}>Zamknij</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
MessageModal.propTypes = {
  openModal: PropTypes.bool,
  closeModal: PropTypes.func,
};

export default MessageModal;



// WEBPACK FOOTER //
// src/routes/eservices/MessageModal.js